import React from "react";
import { CONTACT_DETAILS, FOOTER_LINKS, HEADER_LINKS } from "../../constants";
import ScrollToTop from "../../components/ScrollToTop";
import { TitleTag } from "../../components/TitleTag";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import BreadCrumb from "../../components/BreadCrumb";
import breadcrumbImage from "../../images/social/2150264224.webp";
import Contact from "../../components/Contact";

export const ContactPage = () => {
  return (
    <>
      <ScrollToTop />
      <TitleTag pageTitle="Contact" />
      <Header dropDownLinks={HEADER_LINKS} />
      <BreadCrumb
        title="Contact"
        text="Want to reach out?"
        bgImage={breadcrumbImage}
      />
      <Contact details={CONTACT_DETAILS} />
      <Footer footerLinks={FOOTER_LINKS} />
    </>
  );
};
